import { Trans } from "@lingui/macro";
import { Button, Typography, Box } from "@mui/material"

interface Props {
    setSwitcher: React.Dispatch<React.SetStateAction<string>>
}

export const AlreadySubscribed = (props:Props) => {
    
    return (
        <Box sx={{
            textAlign: "center",
            margin: "auto"
        }}>
            <Typography variant="body1"><Trans>You are already subscribed to our newsletter.</Trans></Typography>
            <Button sx={{margin: "1rem 0 0 0"}} variant="contained" onClick={() => {localStorage.setItem("loyall.newsletter.state", "false"); props.setSwitcher("form")}}><Trans>Sign up again?</Trans></Button>
        </Box>
    )
}